<div id="actionBar">
  <div class="left">
    <span class="sities" (click)="showCompanies()">
      <i class="iconTracsa icon-sities">&#xe813;</i> SITIOS TRACSA
    </span>
  </div>
  <div class="right">
    <span id="buy" class="buy" (mouseover)="showCommerces()" (click)="open()">
      <i class="iconTracsa icon-links">&#xe83d;</i>
      <span>COMPRA EN LÍNEA</span>
    </span>
    <span class="catCard">
      <a routerLink="/cuenta-comercial-cat">
        <div class="contentImage">
          <img
            ngSrc="/general/cat_card_icon_default.svg"
            alt="Financiamiento TRACSA"
            fill
            class="normal"
          />
          <img
            ngSrc="/general/cat_card_icon_hover.svg"
            alt="Financiamiento Maquinaria"
            fill
            class="hover"
          />
        </div>
        <p>CUENTA COMERCIAL CAT</p>
      </a>
    </span>
    @if (false) {
      <span class="catCard">
        <a routerLink="/cat-card">
          <div class="contentImage">
            <img
              ngSrc="/general/cat_card_icon_default.svg"
              alt="Financiamiento TRACSA"
              fill
              class="normal"
            />
            <img
              ngSrc="/general/cat_card_icon_hover.svg"
              alt="Financiamiento Maquinaria"
              fill
              class="hover"
            />
          </div>
          <p>CAT CARD</p>
        </a>
      </span>
    }
    <span class="financiamiento">
      <a routerLink="/financiamiento">
        <div class="contentImage">
          <img
            ngSrc="/general/financiamiento.svg"
            alt="Financiamiento TRACSA"
            fill
            class="normal"
          />
          <img
            ngSrc="/general/financiamiento_yellow.svg"
            alt="Financiamiento Maquinaria"
            fill
            class="hover"
          />
        </div>
        <p>FINANCIAMIENTO</p>
      </a>
    </span>
    <span class="company">
      <a routerLink="/sucursales">
        <i class="iconTracsa icon-branches">&#xe80f;</i>
        <span class="ml-0">SUCURSALES</span>
      </a>
    </span>
    <span class="contact">
      <a routerLink="/contacto">
        <i class="iconTracsa icon-contact">&#xe803;</i> <span>CONTACTO</span>
      </a>
    </span>
    <span class="phone">
      <a href="tel:8005614944" onclick="ga('send', 'event', 'Botonazo', 'Llamada', '800')">
        <svg xmlns="http://www.w3.org/2000/svg" width="10.78" height="13" viewBox="0 0 16.302 20">
          <g id="TEL" transform="translate(-0.303 0.377)">
            <path
              id="Trazado_1"
              data-name="Trazado 1"
              d="M9.841,14.474c.8-.6,1.715-1.218,2.536-.8,1.094.572,2.188,1.144,3.281,1.69.895.472,1.218.994.7,1.914-.82,1.492-2.983,2.71-4.624,2.237A15.7,15.7,0,0,1,.345,3.262c.124-1.69,2.014-3.331,3.679-3.6C5.068-.517,5.466-.019,5.59.975c.149,1.218.3,2.461.447,3.679.124.92-.771,1.566-1.591,2.113C2.458,8.159,7.852,15.866,9.841,14.474Z"
              transform="translate(0 0)"
              fill-rule="evenodd"
            />
          </g>
        </svg>
        <span>800 561 4944</span></a
      ></span
    >
  </div>
</div>
